(() => {
  if (window.dftbCartBreathingInitialized) return;
  window.dftbCartBreathingInitialized = true;
  if (!('IntersectionObserver' in window) || !CSS.supports('scale', '1.12')) return;

  const main = document.getElementById('MainContent');
  const marker = document.querySelector('script[data-dftb-breathing-section]');
  if (!main || !marker) return;
  const sectionId = 'shopify-section-' + marker.dataset.dftbBreathingSection;
  const mobile = matchMedia('(max-width: 768px) and (pointer: coarse)');
  const motion = matchMedia('(prefers-reduced-motion: no-preference)');
  let button = null;
  let visible = false;
  let consumed = false;
  let running = false;
  let timer = null;
  let finishTimer = null;

  function eligible() {
    return button && button.isConnected && mobile.matches && motion.matches &&
      document.visibilityState === 'visible' &&
      !button.disabled && !button.matches('[aria-disabled="true"], [aria-busy="true"], .disabled, .btn--loading') &&
      (!button.dataset.cartState || button.dataset.cartState === 'ready');
  }

  function inView() {
    if (!eligible() || !visible) return false;
    const rect = button.getBoundingClientRect();
    const height = window.visualViewport ? window.visualViewport.height : innerHeight;
    const top = window.visualViewport ? window.visualViewport.offsetTop : 0;
    if (!rect.width || !rect.height || rect.top < top || rect.bottom > top + height - 16) return false;
    const hit = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
    return hit && (hit === button || button.contains(hit));
  }

  function clearDelay() {
    clearTimeout(timer);
    timer = null;
  }

  function finish() {
    running = false;
    clearTimeout(finishTimer);
    if (button) button.removeAttribute('data-dftb-breathing');
    intersection.disconnect();
    changes.disconnect();
    overlayChanges.disconnect();
    mobile.removeEventListener('change', reconcile);
    motion.removeEventListener('change', reconcile);
    document.removeEventListener('visibilitychange', reconcile);
    window.removeEventListener('pagehide', abandon);
    main.removeEventListener('pointerdown', interact, true);
    main.removeEventListener('keydown', interact, true);
    main.removeEventListener('submit', interact, true);
    main.removeEventListener('animationend', ended);
    main.removeEventListener('animationcancel', ended);
  }

  function abandon() {
    consumed = true;
    clearDelay();
    finish();
  }

  function interact(event) {
    if (!button) return;
    const isButton = event.target === button || button.contains(event.target);
    const isSubmit = event.type === 'submit' && event.target === button.form;
    if (isButton || isSubmit) abandon();
  }

  function ended(event) {
    if (button && button.contains(event.target) && event.animationName === 'dftb-cart-text-breathe') finish();
  }

  function reconcile() {
    if (consumed) {
      if (running && !eligible()) finish();
      return;
    }
    const section = document.getElementById(sectionId);
    const next = section && section.querySelector('.product-single__form .dftb-cart-button[data-add-to-cart]');
    if (next !== button) {
      clearDelay();
      if (button) intersection.unobserve(button);
      button = next;
      visible = false;
      if (button) intersection.observe(button);
    }
    if (!inView()) {
      clearDelay();
      return;
    }
    if (timer !== null) return;
    timer = setTimeout(() => {
      timer = null;
      if (!inView() || consumed) return;
      consumed = true;
      running = true;
      intersection.disconnect();
      button.setAttribute('data-dftb-breathing', 'active');
      finishTimer = setTimeout(finish, 1600);
    }, 400);
  }

  const intersection = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.target === button) visible = entry.isIntersecting && entry.intersectionRatio >= 0.99;
    }
    reconcile();
  }, { threshold: [0, 0.99, 1], rootMargin: '0px 0px -16px 0px' });
  const changes = new MutationObserver(reconcile);
  changes.observe(main, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'data-cart-state']
  });
  const overlayChanges = new MutationObserver(reconcile);
  overlayChanges.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  mobile.addEventListener('change', reconcile);
  motion.addEventListener('change', reconcile);
  document.addEventListener('visibilitychange', reconcile);
  window.addEventListener('pagehide', abandon);
  main.addEventListener('pointerdown', interact, { capture: true, passive: true });
  main.addEventListener('keydown', interact, true);
  main.addEventListener('submit', interact, true);
  main.addEventListener('animationend', ended);
  main.addEventListener('animationcancel', ended);
  reconcile();
})();
